import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'basket-loading-state',
    templateUrl: './basket-loading-state.html',
    styleUrl: './basket-loading-state.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketLoadingStateComponent {}
